module.exports = __webpack_public_path__ + "media/soumdorh.c0f9990b.mp3";